module.exports = __webpack_public_path__ + "img/photo-07.4ad7da07.jpg";